
  (function() {
    var flagSpriteUrl = window.joyeAssets.flagsSprite;
    fetch(flagSpriteUrl)
      .then(function(response) { return response.text(); })
      .then(function(svg) {
        var div = document.createElement('div');
        div.style.display = 'none';
        div.innerHTML = svg;
        function appendSvg() {
            document.body.insertBefore(div, document.body.childNodes[0]);
        }
        if (document.body) {
            appendSvg();
        } else {
            document.addEventListener('DOMContentLoaded', appendSvg);
        }
      });
  })();

  
  function createFlagSvg(code) {
    return `<span class="flag-icon"><svg viewBox="0 0 513 342" preserveAspectRatio="xMidYMid slice"><use href="#flag-${code.toLowerCase()}" width="513" height="342"/></svg></span>`;
  }
  var sourceFB = [];

  function convertTimeCutOff(date) {
    var newDate = new Date(date);
    var nameMonths = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return [newDate.getDate(), nameMonths[newDate.getMonth()]];
  }
  var listCollectionsAndDate = [
    {
      productLines: "Aluminum Ornament",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Dec 5 2023, 23:59",
      // dateCA: "Dec 5 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Dec 5 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Color Changing Mug",
      dateUS: "Dec 12 2025, 23:59",
      // dateAU: "Dec 5 2023, 23:59",
      // dateCA: "Dec 5 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 5 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
      dateExpressUS: "Dec 14 2025, 23:59"
    },
    {
      productLines: "Accent Mug",
      dateUS: "Dec 12 2025, 23:59",
      // dateAU: "Dec 5 2023, 23:59",
      // dateCA: "Dec 5 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 5 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
      dateExpressUS: "Dec 14 2025, 23:59"
    },
    {
      productLines: "Shirt And Mug",
      dateUS: "Dec 14 2025, 23:59",
      // dateAU: "Dec 5 2023, 23:59",
      // dateCA: "Dec 5 2023, 23:59",
      dateGB: "Dec 2 2025, 23:59",
      // dateEU: "Dec 5 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Acid Wash T‑Shirt",
      dateUS: "Dec 14 2025, 23:59",
      // dateAU: "Dec 5 2023, 23:59",
      // dateCA: "Dec 5 2023, 23:59",
      dateGB: "Dec 2 2025, 23:59",
      // dateEU: "Dec 5 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Matching Shirts",
      dateUS: "Dec 14 2025, 23:59",
      // dateAU: "Dec 5 2023, 23:59",
      // dateCA: "Dec 5 2023, 23:59",
      dateGB: "Dec 2 2025, 23:59",
      // dateEU: "Dec 5 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Double-Sided Print Shirt",
      dateUS: "Dec 14 2025, 23:59",
      // dateAU: "Dec 5 2023, 23:59",
      // dateCA: "Dec 5 2023, 23:59",
      dateGB: "Dec 2 2025, 23:59",
      // dateEU: "Dec 5 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Long Sleeve T-Shirt",
      dateUS: "Dec 14 2025, 23:59",
      // dateAU: "Dec 5 2023, 23:59",
      // dateCA: "Dec 5 2023, 23:59",
      dateGB: "Dec 2 2025, 23:59",
      // dateEU: "Dec 5 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Poster/Canvas",
      dateUS: "Dec 14 2025, 23:59",
      // dateAU: "Dec 5 2023, 23:59",
      // dateCA: "Dec 5 2023, 23:59",
      dateGB: "Dec 2 2025, 23:59",
      // dateEU: "Dec 5 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Back Printed Shirt",
      dateUS: "Dec 14 2025, 23:59",
      // dateAU: "Dec 5 2023, 23:59",
      // dateCA: "Dec 5 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Dec 5 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Comfort Tee",
      dateUS: "Dec 14 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 2 2025, 23:59",
      // dateEU: "Dec 1 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
      //dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "Scented Soy Candle",
      dateUS: "Dec 14 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 2 2025, 23:59",
      // dateEU: "Dec 1 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
      //dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "Standing Desk Calendar",
      dateUS: "Dec 14 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 2 2025, 23:59",
      // dateEU: "Dec 1 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
      //dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "Mug",
      dateUS: "Dec 12 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 1 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
      //dateExpressUS: "Jun 8 2025, 23:59"
      dateExpressUS: "Dec 14 2025, 23:59"
    },
    {
      productLines: "Custom Print Hoodie",
      dateUS: "Dec 16 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 2 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Classic Tee",
      dateUS: "Dec 14 2025, 23:59:59",
      // dateAU: "Dec 5 2023, 23:59",
      // dateCA: "Dec 5 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Dec 5 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
     {
      productLines: "Shirt",
      dateUS: "Dec 14 2025, 23:59:59",
      // dateAU: "Dec 5 2023, 23:59",
      // dateCA: "Dec 5 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Dec 5 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Poster",
      dateUS: "Dec 12 2025, 23:59",
      //dateUsAI: "Dec 12 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Acrylic Ornament",
      dateUS: "Dec 16 2025, 23:59",
      dateUSUpload: "Dec 15 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Custom Shaped Acrylic Ornament",
      dateUS: "Dec 16 2025, 23:59",
      dateUSUpload: "Dec 15 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Circle Acrylic Ornament",
      dateUS: "Dec 16 2025, 23:59",
      dateUSUpload: "Dec 15 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Wood And Acrylic Ornament",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Dec 3 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Two-Sided Ceramic Ornament",
      dateUS: "Dec 13 2025, 23:59",
      dateUSUpload: "Dec 15 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Ceramic Ornament",
      dateUS: "Dec 13 2025, 23:59",
      dateUSUpload: "Dec 15 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "2 Layers Wooden Ornament",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Dec 3 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Family Wood Ornament",
      dateUS: "Dec 13 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Custom Shaped Wooden Ornament",
      dateUS: "Dec 13 2025, 23:59",
      dateUSUpload: "Dec 15 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Wooden Ornament",
      dateUS: "Dec 16 2025, 23:59",
      dateUSUpload: "Dec 15 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Glass Flat Ball Ornament With Wings",
      dateUS: "Dec 3 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 4 2025, 23:59",
      // dateEU: "Dec 1 2023, 23:59",
      dateOther: "Nov 29 2025, 23:59",
    },
    {
      productLines: "Ball Ornament",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Dec 1 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Window Hanging Suncatcher Ornament",
      dateUS: "Dec 11  2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Suncatcher Ornament",
      dateUS: "Dec 11 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Glass Ornament",
      dateUS: "Dec 13 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Leather Toiletry Bag",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Golf Ball",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Ugly Sweater",
      dateUS: "Dec 1 2025, 23:59",
      dateUSUpload: "Dec 5 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 6 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 29 2025, 23:59",
    },
    {
      productLines: "Pajamas Set",
      dateUS: "Dec 5 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 2 2023, 23:59",
      dateGB: "Dec 6 2025, 23:59",
      //dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 29 2025, 23:59",
    },
    {
      productLines: "Sweatpants",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 2 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      //dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Lounge Pants",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
     // dateExpressUS: "Dec 15 2024, 23:59"
    },
    {
      productLines: "3D Mouse Pad",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Wearable Hooded Blanket",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
    {
      productLines: "Blankets",
      dateUS: "Dec 14 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
      
    },
    {
      productLines: "Circle Jewelry Dish",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Circle Jewelry Dish_FULL",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Jewelry Dish_FULL",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Jewelry Dish_FULL",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Lace Square Jewelry Dish_FULL",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Lotus Jewelry Dish",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Square Jewelry Dish_FULL",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Square Jewelry Dish_FULL And Mug",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Jewelry Dish",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Runner Rug",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Pocket Pillow",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
     // dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "Pillow",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
     {
      productLines: "Bottle Lamp",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 1 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Table Runner",
      dateUS: "Dec 5 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 6 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 29 2025, 23:59",
    },
    {
      productLines: "Doormat",
      dateUS: "Dec 8 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 9 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 2 2025, 23:59",
    },
    {
      productLines: "Engraved Leather Belt",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
    },
    {
      productLines: "Cowhide Belt",
      dateUS: "Dec 7 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
     // dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "Resin Book Page Holder",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
     // dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "Book Page Holder",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
     // dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "LED Night Light",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
     // dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "LED Shadow Box",
      dateUS: "Dec 2 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 3 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Nov 29 2025, 23:59",
     // dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "Leather Journal",
      dateUS: "Dec 6 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 7 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
     // dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "Heart Puzzle Necklace",
      dateUS: "Dec 5 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 6 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
     // dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "Name Plate",
      dateUS: "Dec 12 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 6 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Nov 29 2025, 23:59",
     // dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "Tumbler 20oz",
      dateUS: "Dec 13 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
     // dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "Tumbler Cup",
      dateUS: "Dec 14 2025, 23:59",
      // dateAU: "Dec 1 2023, 23:59",
      // dateCA: "Dec 3 2023, 23:59",
      dateGB: "Dec 8 2025, 23:59",
      // dateEU: "Dec 3 2023, 23:59",
      dateOther: "Dec 1 2025, 23:59",
     // dateExpressUS: "Jun 8 2025, 23:59"
    },
    {
      productLines: "Other",
      dateUS: "Dec 1 2025, 23:59",
      // dateAU: "Nov 30 2023, 23:59",
      // dateCA: "Nov 30 2023, 23:59",
      dateGB: "Dec 2 2025, 23:59",
      // dateEU: "Nov 30 2023, 23:59",
      dateOther: "Nov 30 2025, 23:59",
    },
  ];
  var dateToday = new Date().getTime();
  var codeCountryUser = getCookieByKey('code_country');
  var dayCutOff;
  var monthCutOff;

  function getCookieByKey(key) {
    var keyValue = document.cookie.match("(^|;) ?" + key + "=([^;]*)(;|$)");
    return keyValue
      ? keyValue[2]
      : null;
  }
  function setCookieByKey(key, value, expiry) {
    var expires = new Date();
    expires.setTime(expires.getTime() + expiry * 24 * 60 * 60 * 1000);
    document.cookie = key + "=" + value + "; Path=/;" + expires.toUTCString();
  }
  function renderFlagCountry(respon) {
    var code = respon.detected_values.country.handle;
    document.querySelectorAll('.img-country').forEach(function(el) { el.outerHTML = createFlagSvg(code); });
    document.querySelectorAll('.shipping-country').forEach(function(el) {
      el.textContent = respon.detected_values.country.name;
      el.insertAdjacentHTML('afterbegin', createFlagSvg(code));
    });
    document.querySelectorAll('.shipping-country-last').forEach(function(el) { el.textContent = respon.detected_values.country.name; });

    setCookieByKey('country_name', respon.detected_values.country_name, 1);
    setCookieByKey('code_country', respon.detected_values.country.handle, 1);

  }
  const currencyMap = {
    GBP: "GBP (£)",
    EUR: "EUR (€)",
    CAD: "CAD ($)",
    AUD: "AUD ($)",
    USD: "USD ($)"
  };
  const typeShirt = ['Classic Tee','Pullover Hoodie','Sweatshirt','Youth Sweatshirt']
  function changeCurrencyHeader(currencySelected) {
    document.querySelectorAll('.currencies-country').forEach(function(el) { el.value = currencySelected; });
    document.querySelector(".currency").innerText = currencyMap[currencySelected];
    document.querySelector(".currency-mb").innerText = currencyMap[currencySelected];
  }

  function changeCurrencyByCode(codeCountry) {
    let currencySelected = "USD";
    if (codeCountry === "GB") {
      currencySelected = "GBP";
    } else if (codeCountry === "EUR") {
      currencySelected = "EUR";
    } else if (codeCountry === "CA") {
      currencySelected = "CAD";
    } else if (codeCountry === "AU") {
      currencySelected = "AUD";
    }

    document.querySelectorAll('.currencies-country').forEach(function(el) { el.value = currencySelected; });
    var cwEl = document.querySelector('#currency_wrapper .currencies');
    if (cwEl) { cwEl.value = currencySelected; cwEl.dispatchEvent(new Event('change')); }
    document.querySelector(".currency").innerText = currencyMap[currencySelected];
    document.querySelector(".currency-mb").innerText = currencyMap[currencySelected];
  }
  function defaultCurrencies(codeCountry) {
    const codeCurrency = getCookieByKey('currency');

    if (codeCurrency && codeCurrency !== null) {
      changeCurrencyHeader(codeCurrency);
      var cwEl2 = document.querySelector('#currency_wrapper .currencies');
      if (cwEl2) { cwEl2.value = codeCurrency; cwEl2.dispatchEvent(new Event('change')); }
      return;
    };

    const arrCodeCountries = ["AT", "BE", "CY", "EE", "FI", "FR", "DE", "IE", "GR", "IT", "LV", "LT", "LU", "MT", "PT", "SK", "SI", "ES"];

    let selectedCountry = (arrCodeCountries.indexOf(codeCountry) > -1);

    sourceFB = setSourceFB();

    if (sourceFB.length == 0 || codeCountry == "USD") {
      var cwEl3 = document.querySelector('#currency_wrapper .currencies');
      if (cwEl3) { cwEl3.value = 'USD'; cwEl3.dispatchEvent(new Event('change')); }
      document.querySelector(".currency").innerText = "USD ($)";
      document.querySelector(".currency-mb").innerText = "USD ($)";
      document.querySelectorAll('.currencies-country').forEach(function(el) { el.value = 'USD'; });
      return
    }

    changeCurrencyByCode(selectedCountry ? "EUR" : codeCountry);
  }
  
  async function handleCountryAndGetListCountry() {
    var countryCode = getCookieByKey('code_country')
    if (!countryCode && !getCookieByKey('country_name')) {
      const response = await fetch("/browsing_context_suggestions.json");
      const dataLocation = await response.json();

      if (dataLocation && dataLocation.detected_values) {
        renderFlagCountry(dataLocation);
      }
    } else {
      document.querySelectorAll('.img-country').forEach(function(el) { el.outerHTML = createFlagSvg(countryCode); });
    }

}

  const hasPreviewCutoff = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('preview-cutoff') === 'true';
  };

  const updateNotice = (message, isGreen = false) => {
    if (!hasPreviewCutoff()) {
      var bco = document.querySelector('.box-cut-off');
      if (bco) bco.classList.add('hidden');
      return;
    }
    var trEl = document.querySelector('.cut-off-notice__highlight');
    if (trEl) trEl.innerHTML = message;
    var bco2 = document.querySelector('.box-cut-off');
    if (bco2) { if (isGreen) bco2.classList.add('text--green'); else bco2.classList.remove('text--green'); }
  };
  function showDateCutOff(codeCountry, itemDate) {
    const productCutOff = document.querySelector('.product-cutoff');
    const url = new URL(window.location.href);
    if (!productCutOff) {
      if (url.searchParams.has('preview-cutoff')) {
        url.searchParams.delete('preview-cutoff');
        window.history.replaceState({}, '', url);
      }
      return;
    }
    var dateCutOff; 
    if (codeCountry == "US") {
      dateCutOff = itemDate.dateUS;
    } else if (codeCountry == "AU" && itemDate.dateAU) {
      dateCutOff = itemDate.dateAU;
    } else if (codeCountry == "GB" && itemDate.dateGB) {
      dateCutOff = itemDate.dateGB;
    } else if (codeCountry == "EU" && itemDate.dateEU) {
      dateCutOff = itemDate.dateEU;
    } else if (codeCountry == "CA" && itemDate.dateCA) {
      dateCutOff = itemDate.dateCA;
    } else {
      dateCutOff = itemDate.dateOther;
    }
    // check camp upload or AI or Other
    const campUpload = document.querySelector('.product-upload');
    if(itemDate?.dateUSUpload && codeCountry == "US" && campUpload){
      dateCutOff = itemDate?.dateUSUpload;
    }
    var currentDate = new Date().getTime();
    var dateCutOffTime = new Date(dateCutOff).getTime();
    var timeLeft = dateCutOffTime - currentDate;
    var daysLeft = Math.ceil(timeLeft / (1000 * 60 * 60 * 24));
    var dayCutOff = convertTimeCutOff(dateCutOff)[0];
    var monthCutOff = convertTimeCutOff(dateCutOff)[1];
    console.log("---------------------------------day left", daysLeft)

    const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="183" height="162" viewBox="0 0 183 162" fill="none">
    <path d="M146.875 70.4629L125.482 65.5835C128.969 63.3421 131.55 61.2573 133.408 59.5385C139.396 59.28 145.4 60.0194 151.181 61.9087C151.93 57.0599 152.656 52.2018 153.484 47.3762C151.385 46.7674 149.249 46.4144 147.437 46.1373C145.004 45.7648 142.55 45.6342 140.102 45.7231C140.041 44.375 139.821 43.0231 139.457 41.7008C137.863 35.8615 133.079 28.9557 125.511 27.0951C117.741 25.1854 111.182 29.6034 109.121 30.9905C106.385 32.8371 102.026 36.5583 95.9545 52.2296C95.2509 54.0476 94.501 56.0888 93.7353 58.3432L91.4207 57.815L88.7061 58.434C88.5441 54.3681 88.1311 50.357 87.2794 46.545C85.061 36.6176 81.7762 26.7893 76.3155 17.9081C73.4371 13.226 69.9402 8.84145 65.8322 4.98223C64.1879 3.43762 62.2297 1.63078 60.0966 0C56.9098 3.42465 53.6166 6.77239 50.3502 10.1368C60.3067 17.3475 68.2597 26.8403 73.9055 37.2421C77.321 43.5336 79.9319 50.1652 81.8734 56.9496C81.2753 55.2401 80.6901 53.6649 80.1346 52.2287C74.0629 36.5574 69.705 32.8362 66.9682 30.9895C64.9073 29.6025 58.3486 25.1854 50.578 27.0942C43.0092 28.9548 38.2263 35.8606 36.632 41.6999C36.2005 43.2677 35.97 44.8772 35.97 46.4727C35.97 46.9675 35.9978 47.4623 36.0394 47.9497V47.9571L36.0468 47.9923C36.27 50.4663 37.0773 52.8634 38.5809 54.9676C38.5809 54.9676 41.9093 60.3724 52.4148 66.7111L0 78.6668V97.3403L5.4773 98.5893V141.777L48.0347 151.484L53.8999 152.822L91.4188 161.38L128.943 152.821L150.08 148.001L177.36 141.777V98.5893L182.838 97.3403V78.6668L146.873 70.4638L146.875 70.4629ZM107.804 45.8112C110.186 42.8146 112.922 40.0348 116.257 38.1669C119.648 36.2646 123.081 35.6725 126.465 36.5222C128.526 41.6017 127.934 46.2772 127.934 46.2772C127.833 46.861 127.698 47.4382 127.53 48.0081C121.231 50.0141 115.154 53.158 109.32 56.8199C107.521 57.9494 105.748 59.2549 104.003 60.6828L99.4431 59.6432C101.708 54.736 104.435 50.0391 107.805 45.8102L107.804 45.8112ZM48.155 46.2782C48.155 46.2782 47.5634 41.6026 49.6243 36.5231C53.0083 35.6725 56.4404 36.2655 59.8318 38.1678C63.1667 40.0348 65.9035 42.8155 68.2847 45.8121C71.9733 50.4404 74.8925 55.6292 77.2765 61.0414L63.2519 64.24C55.8275 59.4782 49.3836 53.4054 48.156 46.2782H48.155Z" fill="#D42B24"/>
    <path d="M53.9008 114.352L91.4207 122.91V118.191L53.9008 109.633V114.352Z" fill="#C22921"/>
    <path d="M32.7647 104.812L5.47822 98.5884V103.307L32.7647 109.531V104.812Z" fill="#C22921"/>
    <path d="M146.875 70.4629L113.086 77.9126L147.661 85.6005L150.079 86.1379L150.079 86.1388L128.941 90.9598H128.941L126.513 90.4242L91.4235 82.6882L56.3303 90.4252L53.9018 90.9598V90.9607L91.4207 99.5177V161.379L128.945 152.82V109.633H128.944V90.9607L150.081 86.1388V97.47H150.082V147.999L177.362 141.777V98.5884L182.84 97.3393V78.6659L146.875 70.4629Z" fill="#B1261C"/>
    <path d="M89.6023 72.6904C90.9022 67.2393 92.3438 62.4387 93.7353 58.3423L91.4207 57.8141L88.7061 58.4331C88.8931 63.1086 88.7478 67.8573 88.5598 72.4578L89.6023 72.6895V72.6904Z" fill="#B1261C"/>
    <path d="M104.002 60.6837L99.4422 59.6441C98.9978 60.6068 98.571 61.5788 98.1608 62.5554C97.3905 64.3891 96.5943 66.3007 95.8434 68.2539C98.4858 65.5668 101.208 62.9696 104.002 60.6837Z" fill="#B1261C"/>
    <path d="M81.1929 70.8205C80.1902 67.9778 79.0329 65.1869 77.9274 62.5563C77.7145 62.0495 77.4978 61.5445 77.2756 61.0414L63.2509 64.24C65.6859 65.8012 68.2255 67.2217 70.7225 68.493L81.1929 70.8215V70.8205Z" fill="#B1261C"/>
    <path d="M99.2394 71.357L99.3376 71.3348C103.569 69.4835 108.356 67.1087 112.796 64.2659C108.943 65.8448 105.174 67.7665 101.505 69.9597C100.746 70.4138 99.9903 70.8798 99.2385 71.357H99.2394Z" fill="#B1261C"/>
    <path d="M35.9709 70.4629L52.4176 66.7111C52.4176 66.7111 52.4167 66.7111 52.4158 66.7102L0.000926971 78.6659L8.69646 80.6497L32.7638 86.1397L35.1821 85.6023L69.7596 77.9135L35.97 70.4638L35.9709 70.4629Z" fill="#B1261C"/>
    <path d="M32.7647 86.1388L8.69646 80.6497L32.7647 86.1388Z" fill="#E13B3A"/>
    <path d="M91.4197 99.5177L53.9017 90.9598V90.9607L91.4207 99.5177L128.941 90.9598H128.941L91.4197 99.5177Z" fill="#E13B3A"/>
    <path d="M147.661 85.6005L180.448 78.122L182.839 78.6659L150.079 86.1379L150.079 86.1388L182.84 78.6659L146.875 70.4629L113.086 77.9126L147.661 85.6005Z" fill="#E13B3A"/>
    <path d="M126.513 90.4242L91.4235 82.6882L56.3302 90.4252L91.4198 98.429L126.513 90.4242Z" fill="#E13B3A"/>
    <path d="M88.5589 72.4578L89.6014 72.6895C90.9013 67.2384 92.3428 62.4377 93.7344 58.3413L91.4197 57.8132L88.7052 58.4321C88.8922 63.1077 88.7468 67.8564 88.5589 72.4569V72.4578Z" fill="#E13B3A"/>
    <path d="M104.002 60.6837L99.4422 59.6441C98.9978 60.6068 98.571 61.5788 98.1608 62.5554C97.3905 64.3891 96.5943 66.3007 95.8434 68.2539C98.4858 65.5668 101.208 62.9696 104.002 60.6837Z" fill="#E13B3A"/>
    <path d="M70.7225 68.492L81.1929 70.8205C80.1902 67.9778 79.0329 65.1869 77.9274 62.5563C77.7145 62.0495 77.4978 61.5445 77.2756 61.0414L63.2509 64.24C65.6859 65.8012 68.2255 67.2217 70.7225 68.493V68.492Z" fill="#E13B3A"/>
    <path d="M99.2394 71.357L99.3376 71.3348C103.569 69.4835 108.356 67.1086 112.796 64.2659C108.943 65.8448 105.174 67.7665 101.505 69.9597C100.746 70.4138 99.9903 70.8798 99.2385 71.357H99.2394Z" fill="#E13B3A"/>
    <path d="M2.39146 78.122L35.1821 85.6014L69.7596 77.9126L35.97 70.4629L52.4167 66.7111C52.4167 66.7111 52.4158 66.7111 52.4148 66.7102L0 78.6659L2.39053 78.122H2.39146Z" fill="#E13B3A"/>
    <path d="M182.839 78.6659L180.448 78.122L147.661 85.6004L150.078 86.1379L182.839 78.6659Z" fill="#EB5B5C"/>
    <path d="M128.941 90.9598L126.513 90.4242L91.4197 98.429L56.3302 90.4252L53.9017 90.9598L91.4197 99.5177L128.941 90.9598Z" fill="#EB5B5C"/>
    <path d="M0.000926971 78.6659L8.69646 80.6497L32.7647 86.1388L35.1821 85.6014L2.39146 78.122L0.000926971 78.6659Z" fill="#EB5B5C"/>
    <path d="M128.945 114.351V109.633H128.944V109.632L91.4207 118.191V122.91L128.945 114.351Z" fill="#A0221A"/>
    <path d="M150.082 109.53L177.362 103.307V98.5884L150.082 104.811V109.53Z" fill="#A0221A"/>
    <path d="M147.437 46.1364C145.004 45.7639 142.55 45.6332 140.102 45.7222C140.041 44.374 139.821 43.0221 139.457 41.6999C137.863 35.8606 133.079 28.9548 125.511 27.0942C117.741 25.1845 111.182 29.6025 109.121 30.9895C106.385 32.8362 102.026 36.5574 95.9545 52.2287C95.2509 54.0466 94.501 56.0879 93.7353 58.3423C92.3437 62.4387 90.9031 67.2393 89.6023 72.6904L88.5598 72.4587C88.7478 67.8583 88.8931 63.1095 88.7061 58.434C88.5441 54.3681 88.1311 50.357 87.2794 46.545C85.061 36.6176 81.7762 26.7893 76.3155 17.9081C73.4371 13.226 69.9402 8.84145 65.8322 4.98223C64.1879 3.43762 62.2297 1.63078 60.0966 0C56.9098 3.42465 53.6166 6.77239 50.3502 10.1368C60.3067 17.3475 68.2597 26.8403 73.9055 37.2421C77.321 43.5336 79.9319 50.1652 81.8734 56.9496C81.2753 55.2401 80.6901 53.6649 80.1346 52.2287C74.0629 36.5574 69.705 32.8362 66.9682 30.9895C64.9073 29.6025 58.3486 25.1854 50.578 27.0942C43.0092 28.9548 38.2263 35.8606 36.632 41.6999C36.2005 43.2677 35.97 44.8772 35.97 46.4727C35.97 46.9675 35.9978 47.4623 36.0394 47.9497V47.9571L36.0468 47.9923C36.27 50.4663 37.0773 52.8634 38.5809 54.9676C38.5809 54.9676 41.9093 60.3724 52.4148 66.7111C52.4148 66.7111 52.4158 66.7111 52.4167 66.7121L35.97 70.4638L69.7596 77.9135L35.1821 85.6023L32.7638 86.1397V97.4718V148.001L48.0356 151.485L53.9008 152.823V109.634V90.9617L43.2897 88.5414L53.9017 90.9617L56.3293 90.4261L91.4225 82.6891L126.513 90.4252L128.941 90.9607L150.078 86.1397L147.66 85.6023L113.085 77.9145L146.875 70.4647L125.482 65.5853C128.969 63.3439 131.55 61.2591 133.408 59.5403C139.396 59.2818 145.4 60.0212 151.181 61.9105C151.93 57.0617 152.656 52.2036 153.484 47.378C151.385 46.7692 149.249 46.4162 147.437 46.1392V46.1364ZM48.155 46.2782C48.155 46.2782 47.5634 41.6026 49.6243 36.5231C53.0083 35.6725 56.4404 36.2655 59.8318 38.1678C63.1667 40.0348 65.9035 42.8155 68.2847 45.8121C71.9733 50.4404 74.8925 55.6292 77.2765 61.0414C77.4978 61.5445 77.7154 62.0495 77.9283 62.5564C79.0338 65.1869 80.1911 67.9787 81.1938 70.8205L70.7234 68.492C68.2273 67.2217 65.6868 65.8012 63.2519 64.239C55.8275 59.4773 49.3836 53.4045 48.156 46.2772L48.155 46.2782ZM99.2394 71.357C99.9903 70.8798 100.746 70.4138 101.506 69.9597C105.174 67.7665 108.944 65.8448 112.797 64.2659C108.356 67.1086 103.57 69.4835 99.3385 71.3348L99.2404 71.357H99.2394ZM127.933 46.2782C127.832 46.8619 127.697 47.4392 127.529 48.009C121.23 50.0151 115.153 53.159 109.319 56.8208C107.52 57.9503 105.747 59.2559 104.002 60.6837C101.209 62.9696 98.4858 65.5668 95.8434 68.2539C96.5943 66.3007 97.3905 64.3891 98.1608 62.5554C98.571 61.5779 98.9978 60.6068 99.4422 59.6441C101.707 54.7369 104.434 50.0401 107.804 45.8112C110.186 42.8146 112.922 40.0348 116.257 38.1669C119.648 36.2646 123.081 35.6725 126.465 36.5222C128.526 41.6017 127.934 46.2772 127.934 46.2772L127.933 46.2782Z" fill="#F6CC38"/>
    <path d="M150.081 86.1388L128.944 90.9607V109.633H128.945V152.822L150.082 148V97.47H150.081V86.1388Z" fill="#F6CC38"/>
    <path d="M99.1339 71.4237C99.2015 71.3941 99.27 71.3644 99.3376 71.3348L99.2394 71.357C99.2043 71.3793 99.1691 71.4015 99.1339 71.4237Z" fill="#F9DA38"/>
    <path d="M75.136 76.7164C77.745 77.554 80.5263 78.3657 83.4908 79.1394C83.1631 77.2862 82.6696 75.4043 82.0909 73.5299C78.8746 72.2892 74.8582 70.5963 70.7225 68.4911C68.2264 67.2208 65.6859 65.8003 63.2509 64.2381C55.8266 59.4764 49.3827 53.4036 48.155 46.2763C48.155 46.2763 47.5634 41.6008 49.6244 36.5212C48.3013 36.8557 46.9922 37.4061 45.6904 38.1937C42.7592 39.957 39.9882 42.1938 38.3938 45.2246C37.0079 47.8589 36.6746 51.1826 37.9207 53.8307C37.9559 53.9076 37.9902 53.9836 38.0393 54.0605C38.192 54.3737 38.3735 54.6739 38.5827 54.9667C38.5827 54.9667 41.9111 60.3715 52.4167 66.7102C52.4167 66.7102 52.4176 66.7102 52.4185 66.7111C57.8755 70.0033 65.2683 73.5475 75.1369 76.7164H75.136Z" fill="#F4BE39"/>
    <path d="M137.507 54.9676C137.717 54.6748 137.897 54.3756 138.051 54.0614C138.1 53.9845 138.134 53.9086 138.169 53.8317C139.416 51.1835 139.081 47.8598 137.696 45.2256C136.102 42.1947 133.331 39.9579 130.4 38.1947C129.098 37.4071 127.789 36.8567 126.466 36.5222C128.527 41.6017 127.935 46.2772 127.935 46.2772C127.834 46.861 127.699 47.4382 127.53 48.0081C125.641 54.4043 119.631 59.8896 112.798 64.265C108.358 67.1077 103.571 69.4826 99.3404 71.3339C99.2718 71.3635 99.2043 71.3932 99.1367 71.4228C97.2896 72.2271 95.5518 72.9313 94.0001 73.5289C93.4223 75.4034 92.9279 77.2844 92.6002 79.1385C108.074 75.0995 118.563 70.0329 125.485 65.5826C128.972 63.3412 131.553 61.2564 133.411 59.5375C136.392 56.78 137.509 54.9658 137.509 54.9658L137.507 54.9676Z" fill="#F4BE39"/>
    <path d="M53.9008 109.633V90.9607L43.2897 88.5405L53.9017 90.9607L56.3293 90.4252L91.4225 82.6882L113.085 77.9126L146.875 70.4629L125.482 65.5835C118.56 70.0339 108.071 75.1013 92.5974 79.1394C92.9242 77.2862 93.4186 75.4043 93.9973 73.5299C94.5445 71.7564 95.1759 69.9885 95.8434 68.253C96.5943 66.2997 97.3905 64.3882 98.1608 62.5545C98.571 61.577 98.9978 60.6059 99.4422 59.6432C101.707 54.736 104.434 50.0391 107.804 45.8102C110.186 42.8137 112.922 40.0339 116.257 38.1659C119.648 36.2636 123.081 35.6716 126.465 36.5212C127.788 36.8557 129.097 37.4061 130.399 38.1937C133.33 39.957 136.101 42.1938 137.695 45.2246C139.081 47.8589 139.415 51.1825 138.168 53.8307C138.133 53.9076 138.099 53.9836 138.05 54.0605C137.897 54.3737 137.716 54.6739 137.506 54.9667C139.01 52.8624 139.818 50.4654 140.04 47.9914L140.047 47.9562V47.9488C140.089 47.4614 140.116 46.9666 140.116 46.4718C140.116 46.2216 140.111 45.9715 140.1 45.7203C140.04 44.3722 139.819 43.0203 139.455 41.6981C137.861 35.8587 133.077 28.9529 125.509 27.0923C117.739 25.1827 111.18 29.6006 109.119 30.9877C106.383 32.8344 102.024 36.5555 95.9527 52.2268C95.249 54.0448 94.4991 56.086 93.7334 58.3404C92.3419 62.4368 90.9013 67.2374 89.6005 72.6885C89.5329 72.9721 89.4662 73.2565 89.3986 73.5428L88.5033 73.7421C88.47 74.5324 88.4357 75.3182 88.4024 76.0983C88.5857 75.9028 88.77 75.7064 88.9533 75.509C88.682 76.7497 88.4163 78.0275 88.1636 79.3321C88.0821 79.3516 88.0025 79.3636 87.9265 79.3664C87.784 78.6279 87.6367 77.8978 87.4868 77.1778C87.3581 76.5598 87.2275 75.9492 87.0951 75.3469C85.5008 68.1334 83.6278 61.9624 81.8715 56.9477C81.2734 55.2382 80.6883 53.663 80.1328 52.2268C74.0611 36.5555 69.7031 32.8344 66.9663 30.9877C64.9054 29.6006 58.3467 25.1836 50.5761 27.0923C43.0073 28.9529 38.2244 35.8587 36.6301 41.6981C36.1987 43.2658 35.9681 44.8753 35.9681 46.4709C35.9681 46.9657 35.9959 47.4605 36.0376 47.9479V47.9553L36.045 47.9905C36.2681 50.4645 37.0754 52.8615 38.579 54.9658C38.3698 54.673 38.1892 54.3737 38.0355 54.0596C37.9865 53.9827 37.9522 53.9067 37.917 53.8298C36.6709 51.1816 37.0051 47.858 38.3901 45.2237C39.9845 42.1928 42.7555 39.9561 45.6867 38.1928C46.9885 37.4052 48.2976 36.8548 49.6206 36.5203C53.0046 35.6697 56.4367 36.2627 59.8281 38.165C63.163 40.0321 65.8998 42.8127 68.281 45.8093C71.9696 50.4376 74.8888 55.6264 77.2728 61.0386C77.4941 61.5417 77.7117 62.0467 77.9246 62.5536C79.0301 65.1841 80.1874 67.9759 81.1901 70.8178C81.5077 71.7175 81.8095 72.6218 82.0891 73.528C82.6668 75.4025 83.1612 77.2834 83.489 79.1375C80.5244 78.3638 77.7432 77.5522 75.1341 76.7145L69.7587 77.9098L35.1812 85.5986L32.7629 86.136V97.4681V147.997L48.0347 151.481L53.8999 152.819V109.63L53.9008 109.633Z" fill="#F9DA38"/>
    </svg>`

     if (  daysLeft == 1) {
      updateNotice(`${svg}Order today to get your items before Christmas!`, true);
      return
    }
    if ( daysLeft <= 2 && daysLeft > 0) {
      updateNotice(`${svg}Order by  <strong>${monthCutOff} ${dayCutOff}</strong> to receive your items before Christmas!`);
      return
    }
    
    if (currentDate < dateCutOffTime){
      updateNotice(`${svg}Arrives Before Christmas!`, true);
      return 
    }

    if(itemDate?.dateExpressUS && codeCountry == "US"){
      var dateCutOffExpressUS = new Date(itemDate?.dateExpressUS).getTime();
      if(currentDate < dateCutOffExpressUS){
        updateNotice(`${svg}Arrives Before Christmas With Express Shipping!`, true);
      }else{
        
        updateNotice(`${svg}Orders placed after <strong>${monthCutOff} ${dayCutOff}</strong> may not be delivered by Christmas`);
      }
    }else{
      updateNotice(`${svg}Orders placed after <strong>${monthCutOff} ${dayCutOff}</strong> may not be delivered by Christmas`);
    } 

    //  show cutoff Christmas
    // if (currentDate < dateCutOffTime){
    //   updateNotice('📦 Arrives Before Christmas!', true);
    //   return 
    // }

    // if(itemDate?.dateExpressUS && codeCountry == "US"){
    //   var dateCutOffExpressUS = new Date(itemDate?.dateExpressUS).getTime();
    //   if(currentDate < dateCutOffExpressUS){
    //     updateNotice('📦 Arrives Before Christmas With Express Shipping!', true);
    //   }else{
    //     dayCutOff = convertTimeCutOff(dateCutOffExpressUS)[0];
    //     monthCutOff =  convertTimeCutOff(dateCutOffExpressUS)[1]
    //     updateNotice(`📦 Orders placed after <strong>${monthCutOff} ${dayCutOff}</strong> may not be delivered by Christmas`);
    //   }
    // }else{
    //   updateNotice(`📦 Orders placed after <strong>${monthCutOff} ${dayCutOff}</strong> may not be delivered by Christmas`);
    // } 
    // End show cutoff Christmas
    
}
  function loadDateCutOff(codeCountryParam = false) {
    const arrCodeCountriesEU = ["AT","AL","AD","BY","BE","BA","BG","HR","CY","CZ","DK","EE","FI","FR","DE","GR","HU","IS","IE","IT","XK","LV","LI","LT","LU","MK","MT","MD","MC","ME","NL","NO","PL","PT","RO","RU","SM","RS","SK","SI","ES","SE","CH","TR","UA","VA"];
    if (codeCountryParam) {
        codeCountryUser = codeCountryParam;
    }

    if (arrCodeCountriesEU.includes(codeCountryParam)) {
        codeCountryUser = 'EU'
    }
    var nameProduct = (document.querySelector('.product_name_title') || {}).textContent || '';
    var typeProduct = (document.querySelector('.product-type') || {}).textContent || '';
    var tagProduct = (document.querySelector('.product-tags') || {}).textContent || '';
    var vendorProduct = (document.querySelector('.product-vendor') || {}).textContent || '';

    if (typeProduct.includes('AMZ') || vendorProduct.includes('AMZ')) {
      var bcoEl = document.querySelector('.box-cut-off');
      if (bcoEl) bcoEl.classList.add('hidden');
      return;
    }
    var cutoffDate = listCollectionsAndDate.find(itemDate =>
      nameProduct.indexOf('Shirt') > 0 && typeShirt.includes(itemDate.productLines) && document.querySelector(`input[type='radio'][value='${itemDate.productLines}']:checked`) ||
      itemDate.productLines == typeProduct || itemDate.productLines == tagProduct
    );

    if (!cutoffDate) {
      cutoffDate = listCollectionsAndDate.find(item => item.productLines === "Other");
    }
    if(cutoffDate){
      showDateCutOff(codeCountryUser, cutoffDate);
    }
    /*for (var index = 0; index < listCollectionsAndDate.length; index++) {
      var itemDate = listCollectionsAndDate[index];
      if (
        nameProduct.indexOf('Shirt') > 0 && typeShirt.includes(itemDate.productLines) && document.querySelector(`input[type='radio'][value='${itemDate.productLines}']:checked`) ||
        itemDate.productLines == typeProduct || itemDate.productLines == tagProduct) {
        showDateCutOff(codeCountryUser, itemDate);
        break;
      } else {
        showDateCutOff(codeCountryUser, itemDate);
      }
    }*/

  }

  loadDateCutOff('US');
  setCookieByKey("code_country", 'US', 2);
  setCookieByKey("country_name", 'United States', 2);
  
  document.addEventListener('DOMContentLoaded', function () {
    showAndHideGiftBoxOrnament();
    var locSelect = document.getElementById('localization-select');
    if (locSelect) {
      locSelect.addEventListener('change', function() {
        var selectedCountry = this.value;
        document.querySelectorAll("input[name='country_code']").forEach(function(el) { el.value = selectedCountry; });
      });
    }
  });
  function showAndHideGiftBoxOrnament(countryCode){
    if(!countryCode){
      codeCountry = getCookieByKey('code_country') || 'US';
    }

    var productBaseEl = document.querySelector('.product-base');
    var productBase = productBaseEl ? productBaseEl.textContent : '';
    var gBox = document.querySelector('.gift-box-wrapper.box');
    var gCard = document.querySelector('.gift-box-wrapper.card');

    if(codeCountry != 'US' && productBase == 'LED Night Light'){
       if (gBox) gBox.style.display = 'none';
       return
    }
    
    if(!productBase.includes('Ornament') && !productBase.includes('Suncatcher Ornament')) {
       if (gBox) gBox.style.display = '';
       if(codeCountry == 'US' && gCard) gCard.style.display = '';
       return
    };
    if(productBase == 'Window Hanging Suncatcher Ornament'){
      if (gBox) gBox.style.display = '';
      if (gCard) gCard.style.display = 'none';
      return
    }
    var blackBox = window.joyeAssets.giftBoxBlack;
    var redBox = window.joyeAssets.giftBoxRed;
    var redVariant = 44464294264988;
    var blackVariant = 44464294232220;
    if(productBase.includes('Hanging Suncatcher Ornament')){
      
   
      var fgbInput2 = document.querySelector('#form-gift-box input.product-variant-id');
      if (fgbInput2) fgbInput2.value = blackVariant;
      var gImg2 = document.querySelector('.gift-box-wrapper .gift-box-content-img img');
      if (gImg2) { gImg2.setAttribute('src', blackBox); gImg2.setAttribute('srcset', blackBox); }
      if (gBox) gBox.style.display = '';
      if (gCard) gCard.style.display = 'none';
      return;
    }
    if(codeCountry == 'US'){
     if (gBox) gBox.style.display = '';
     if (gCard) gCard.style.display = '';
      return
    }
    if (gBox) gBox.style.display = 'none';
    if (gCard) gCard.style.display = 'none';
  }

  function getUTMAttributes() {
    // Retrieve UTMAttributes from Shopify cookie
    var shopifyCookieRegEx = /^_shopify_sa_p/;
    var utmRegEx = /^utm_/;
    var timestampRegEx = /^_shopify_sa_t/;
    var utmParams = {};
    var shopifyCookie = "";
    var timestamp = "";
    document.cookie.split(";")
      .map(function (s) {
        return s.trim();
      })
      .forEach(function (s) {
        if (shopifyCookieRegEx.test(s)) {
          shopifyCookie = s;
        }
        if (timestampRegEx.test(s)) {
          timestamp = decodeURIComponent(s.split("=")[1]);
        }
        return;
      });
    var utmValuesFromCookie = shopifyCookie.split("=")[1];
    decodeURIComponent(utmValuesFromCookie)
      .split("&")
      .forEach(function (s) {
        var key = s.split("=")[0];
        var val = s.split("=")[1];
        if (utmRegEx.test(key)) {
          return utmParams[key] = val;
        }
        return;
      });
    if (!Object.keys(utmParams).length) {
      return undefined;
    }
    return utmParams;
  }
  function getUTMByURL() {
    var urlParams = new URLSearchParams(window.location.search);
    var utmParams = {};

    urlParams.forEach(function (value, key) {
      if (key.startsWith("utm_")) {
        utmParams[key] = value;
      }
    });

    if (Object.keys(utmParams).length === 0) {
      return undefined;
    }

    return utmParams;
  }
  function setSourceFB() {
    var source = ['fb', 'ig', 'facebook', 'instagram', 'an', 'tiktok'];
    var sourceFB = [];

    var utm_attributes = getUTMAttributes();
    if (utm_attributes) {
      Object.keys(utm_attributes).forEach(function (key) {
        if (source.includes(utm_attributes[key])) {
          sourceFB.push(utm_attributes[key])
        }
      });
    }

    if (sourceFB.length == 0) {
      const data = getUTMByURL();
      if (data) {
        Object.keys(data).forEach(function (key) {
          if (source.includes(data[key])) {
            sourceFB.push(data[key])
          }
        });
      }
    }
    return sourceFB;
  }
